import React from 'react';
import { bool } from 'prop-types';

import styled, { keyframes } from 'styled-components/macro';

const coverContainer = `
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  background-color: rgba(255, 255, 255, 0.8);
`;

export const Container = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  ${({ cover }) => cover && coverContainer}
`;

export const Wrapper = styled.div.attrs(({ cover }) => ({
  cover,
  'data-testid': 'loader-wrapper'
}))`
  position: relative;
  width: 40px;
  height: 40px;
  margin: 1em;
`;

const circleFadeDelay = keyframes`
  0%,
  39%,
  100% { opacity: 0; }
  40% { opacity: 1; }
`;

export const Circle = styled.div.attrs((props) => ({
  'data-testid': 'loader-circle',
  ...props
}))`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transform: ${({ rotate }) => `rotate(${rotate}deg)`};

  &::before {
    content: '';
    display: block;
    width: 15%;
    height: 15%;
    margin: 0 auto;
    background-color: #999;
    border-radius: 100%;
    animation: ${circleFadeDelay} 1.2s infinite ease-in-out both;
    animation-delay: ${({ delay }) => `${delay}s`};
  }
`;

/** Indicates a loading status */
const LoadingIndicator = ({ cover }) => (
  <Container cover={cover} data-testid="loader">
    <Wrapper data-testid="loader-wrapper">
      <Circle />
      <Circle rotate={30} delay={-1.1} />
      <Circle rotate={60} delay={-1} />
      <Circle rotate={90} delay={-0.9} />
      <Circle rotate={120} delay={-0.8} />
      <Circle rotate={150} delay={-0.7} />
      <Circle rotate={180} delay={-0.6} />
      <Circle rotate={210} delay={-0.5} />
      <Circle rotate={240} delay={-0.4} />
      <Circle rotate={270} delay={-0.3} />
      <Circle rotate={300} delay={-0.2} />
      <Circle rotate={330} delay={-0.1} />
    </Wrapper>
  </Container>
);

LoadingIndicator.propTypes = {
  /** If true, it will be centered in the container and partially hide its contents */
  cover: bool
};

export default LoadingIndicator;
